module.exports = __webpack_public_path__ + "static/media/wallet_to_wallet.f6421e9a.svg";